import { useCallback } from 'react'

import { styled } from 'nativewind'

import { Icon } from '../icons'
import { XStack } from '../layout'
import Pressable from '../pressable'
import { Text } from '../typography'
import { useSelectContext } from './useSelectContext'

const OptionContainer = styled(Pressable)

export function Option({
  name,
  children,
  showToggle = false,
  optionContainerStyle,
  optionTextStyle,
  backgroundColor,
  iconColor,
  textColor,
  selectedValue,
  displayText,
  stylingOverrides = {
    innerContainer: '',
  },
}) {
  const { dispatch, state } = useSelectContext()

  const defaultContainerStyle = 'h-14 w-full justify-center rounded-lg'
  const defaultTextStyle = ' pl-3 text-base font-semibold'

  const isSelected = useCallback(
    (value: string) => {
      if (state.mode === 'single') {
        return value === state.selectedItem || value === selectedValue
      } else {
        return (
          state.selectedItem?.includes(value) || selectedValue?.includes(value)
        )
      }
    },
    [state.selectedItem, state.mode, selectedValue]
  )

  const getIconType = useCallback(
    (value: string) => {
      if (state.mode === 'single') {
        if (isSelected(value)) return 'RadioOn'
        else return 'RadioOff'
      }
      if (state.mode === 'multi') {
        if (isSelected(value)) return 'CheckBoxTickFilled'
        else return 'CheckBox'
      }
    },
    [showToggle, state.selectedItem, selectedValue]
  )

  return (
    <OptionContainer
      onPress={() => {
        dispatch({
          type: 'SELECT_ITEM',
          item: name,
          displayText,
        })
      }}
      className={` ${
        isSelected(name)
          ? backgroundColor?.active || 'bg-primary-150'
          : backgroundColor?.inActive || 'bg-grays-30'
      } ${optionContainerStyle ?? defaultContainerStyle} `}
    >
      <XStack className={`items-center ${stylingOverrides?.innerContainer}`}>
        {showToggle && (
          <Icon
            type={getIconType(name)}
            color={
              isSelected(name)
                ? iconColor?.active || 'white'
                : iconColor?.inActive || 'black'
            }
            className={`ml-2`}
          />
        )}
        <Text
          className={`  ${
            isSelected(name)
              ? textColor?.active || 'text-neutral-white100'
              : textColor?.inActive || 'text-black'
          } ${optionTextStyle ?? defaultTextStyle} `}
        >
          {children}
        </Text>
      </XStack>
    </OptionContainer>
  )
}
